import React, { useState } from 'react';
import api from '../services/api';

/**
 * Componente para cancelar pedidos - Funcionalidade administrativa
 */
const CancelamentoModal = ({ 
  isOpen, 
  onClose, 
  pedido, 
  onCancelSuccess 
}) => {
  const [motivo, setMotivo] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Função para gerar mensagem contextual
  const getContextualMessage = () => {
    const isPago = pedido?.pagoTexto === 'Sim';
    const isRascunho = pedido?.status === 'Rascunho';
    const isConcluido = pedido?.status === 'Concluido';
    
    if (isRascunho) {
      return 'Esta ação excluirá o pedido em rascunho permanentemente.';
    }
    
    if (isConcluido) {
      return 'Esta ação cancelará um pedido já concluído. Esta operação pode impactar registros relacionados.';
    }
    
    if (isPago) {
      return 'Esta ação cancelará o pedido permanentemente. Como o pedido já foi pago, as ações automáticas serão revertidas.';
    }
    
    return 'Esta ação cancelará o pedido permanentemente.';
  };
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!motivo.trim()) {
      setError('Informe o motivo do cancelamento');
      return;
    }

    try {
      setSubmitting(true);
      
      const response = await api.patch(`/pedidos/${pedido.idProduto}/cancel`, { motivo });
      
      if (response.data.success) {
        setSuccess('Pedido cancelado com sucesso!');
        setTimeout(() => {
          onCancelSuccess(response.data.data);
          onClose();
          setMotivo('');
        }, 1500);
      } else {
        setError(response.data.message || 'Erro ao cancelar pedido');
      }
      
    } catch (error) {
      console.error('Erro ao cancelar pedido:', error);
      setError(error.response?.data?.message || 'Erro interno do servidor');
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-red-600">Cancelar Pedido</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
            disabled={submitting}
          >
            ✕
          </button>
        </div>

        <div className="mb-4 p-3 bg-gray-50 rounded">
          <p className="text-sm text-gray-600">
            <strong>Pedido:</strong> #{pedido?.idProduto}
          </p>
          <p className="text-sm text-gray-600">
            <strong>Valor:</strong> R$ {pedido?.valor && !isNaN(pedido.valor) ? Number(pedido.valor).toFixed(2) : '0,00'}
          </p>
          <p className="text-sm text-gray-600">
            <strong>Status Atual:</strong> {pedido?.status}
          </p>
          <p className="text-sm text-gray-600">
            <strong>Pago:</strong> {pedido?.pagoTexto || 'Não'}
          </p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-600 rounded">
            {error}
          </div>
        )}

        {success && (
          <div className="mb-4 p-3 bg-green-50 border border-green-200 text-green-600 rounded">
            {success}
          </div>
        )}

        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded">
          <p className="text-sm text-red-800">
            <strong>Atenção:</strong> {getContextualMessage()}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Motivo do Cancelamento *
            </label>
            <textarea
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              required
              disabled={submitting}
              rows={3}
              placeholder="Descreva o motivo do cancelamento..."
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500"
            />
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              className="flex-1 px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
            >
              Voltar
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:opacity-50"
            >
              {submitting ? 'Cancelando...' : 'Confirmar Cancelamento'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CancelamentoModal;
